export var props = {
  list: {
    type: Array,
    default: () => []
  },
  fieldsGetter: {
    type: Object,
    default: () => {}
  }
};